import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'open_with_faire-shopify_offer_benefits_upsells_toast_toggle-click';

/**
 * Fires when clicking the open/close toggle of the faire shopify benefits toast
 */
export function trackOpenWithFaireShopifyOfferBenefitsUpsellsToastToggleClick(
  customParameterToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken },
  });
}
